import { Icon } from '@fluentui/react/lib/Icon';
import React from 'react';
import styled from 'styled-components/macro';
import { HealthStatus } from '../../../config/spaces/spaceConfig';

export interface HealthStatusIndicatorProps {
    status: HealthStatus;
}

export default function HealthStatusIndicator(props: HealthStatusIndicatorProps): JSX.Element {
    const { status } = props;

    return <Wrapper style={{ borderColor: status.borderColor }}>
        {status.icon && <Icon iconName={status.icon} style={{ color: status.borderColor }} />}
        <span>{status.message}</span>
        {status.linkText && <a href={status.linkUrl} target="_blank" rel="noopener noreferrer">{status.linkText}</a>}
    </Wrapper>
}

const Wrapper = styled.div`
    display: flex;
    border: solid .1rem;
    padding: 0.8rem 1.4rem;
    line-height: 100%;

    i {
        margin-right: .5rem;
    }

    a {
        margin-left: 1rem;
    }
`;
